import Banner from '../../Alumni/Partials/Banner';
import './Centers.css';
import AboutSection from "./Partials/AboutSection";



import French from './Partials/French';
import Scope from './Partials/Scope';
import OnlineCourse from './Partials/OnlineCourse';
import Curriculum from './Partials/Curriculum';
import Eligibility from './Partials/Eligibility';
import Contact from './Partials/Contact';

const Centers= () => {

  return (
    <div className="centers-page">
      <Banner />
      <AboutSection/>
      <French/>
      <Scope/>
      <OnlineCourse/>
      <Curriculum/>
      <Eligibility/>
      <Contact/>
    </div>
  )
}

export default Centers;